import { render, staticRenderFns } from "./RequestAuditFlowDown.vue?vue&type=template&id=0231d920"
import script from "./RequestAuditFlowDown.vue?vue&type=script&lang=js"
export * from "./RequestAuditFlowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports